import { render, staticRenderFns } from "./CommentUpdateModal.vue?vue&type=template&id=d9767114&scoped=true"
import script from "./CommentUpdateModal.vue?vue&type=script&lang=js"
export * from "./CommentUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./CommentUpdateModal.vue?vue&type=style&index=0&id=d9767114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9767114",
  null
  
)

export default component.exports